/* Created by Interactive 63 - https://interactive63.com */
/**
 * Even distribution of selected keyframes along a track.
 */
import type { Project } from '../model/types';

/** Whether any track has three or more of the given keyframes, which distribution needs. */
export function canDistribute(project: Project, keyframeIds: readonly string[]): boolean {
  const selected = new Set(keyframeIds);
  return project.tracks.some((t) => t.keyframes.filter((kf) => selected.has(kf.id)).length >= 3);
}

/**
 * Spaces three or more selected keyframes on each track evenly between the first and last,
 * rounding to whole milliseconds. The first and last keep their times.
 */
export function distributeEvenly(project: Project, keyframeIds: readonly string[]): void {
  const selected = new Set(keyframeIds);
  for (const track of project.tracks) {
    const chosen = track.keyframes.filter((kf) => selected.has(kf.id));
    const first = chosen[0];
    const last = chosen[chosen.length - 1];
    if (chosen.length < 3 || !first || !last) continue;
    const step = (last.time - first.time) / (chosen.length - 1);
    chosen.forEach((kf, index) => {
      kf.time = Math.round(first.time + step * index);
    });
    track.keyframes.sort((a, b) => a.time - b.time);
  }
}
